import { ActionTypes } from '../../constants/ActionTypes';
import {
  IArchiveFolderDetail,
  IArchiveReducer,
  IArchiveResponse,
  IDataNode,
} from '../../interfaces';

const INIT_STATE: IArchiveReducer = {
  archiveFoldersDetails: [],
  organizationArchiveFoldersDetails: [],
  archiveModel: {
    letterCode: [],
    folderCode: '',
    move: false,
    archiveId: null,
    showInSubDepartment: false,
  },
  fastArchiveModel: {
    employeePositionFastArchiveId: '',
    letterCodes: [],
    currentFolderCode: '',
  },
};

function updateTreeData(
  list: IDataNode[],
  key: React.Key,
  children: IDataNode[],
): IDataNode[] {
  return list.map((node) => {
    if (node.key === key) {
      return {
        ...node,
        children,
      };
    } else if (node.children) {
      return {
        ...node,
        children: updateTreeData(node.children, key, children),
      };
    }
    return node;
  });
}

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.GET_PERSONAL_ARCHIVE_FOLDERS: {
      return {
        ...state,
        archiveId: action.payload,
        archiveFoldersDetailsLoding: false,
      };
    }

    case ActionTypes.SET_PERSONAL_ARCHIVE: {
      const { archiveModel } = state as IArchiveReducer;

      return {
        ...state,
        archiveModel,
      };
    }

    case ActionTypes.SET_PERSONAL_ARCHIVE_SUCCESS: {
      return {
        ...state,
      };
    }

    case ActionTypes.SET_ORGANIZATION_ARCHIVE: {
      const { archiveModel } = state as IArchiveReducer;
      return {
        ...state,
        archiveModel,
      };
    }

    case ActionTypes.SET_ORGANIZATION_ARCHIVE_SUCCESS: {
      return {
        ...state,
      };
    }

    case ActionTypes.FETCH_PERSONAL_ARCHIVE_FOLDERS_SUCCESS: {
      const lstTemp: IArchiveFolderDetail[] = [];
      action.payload.map((item: IArchiveResponse) => {
        lstTemp.push({
          archiveId: null,
          title: item.name,
          key: item.archiveId,
          isLeaf: !item.hasChild,
          parentId: item.archiveIdParent,
        });
      });
      let newTree;
      if (lstTemp[0]?.parentId) {
        newTree = updateTreeData(
          state.archiveFoldersDetails,
          lstTemp[0].parentId,
          lstTemp,
        );
      } else newTree = lstTemp;

      return {
        ...state,
        archiveFoldersDetails: newTree,
        archiveFoldersDetailsLoding: false,
      };
    }

    case ActionTypes.GET_ORGANIZATION_ARCHIVE_FOLDERS: {
      return {
        ...state,
        organizationArchiveId: action.payload,
        organizationArchiveFoldersDetailsLoading: false,
      };
    }

    case ActionTypes.FETCH_ORGANIZATION_ARCHIVE_FOLDERS_SUCCESS: {
      const lstTemp: IArchiveFolderDetail[] = [];
      action.payload.map((item: IArchiveResponse) => {
        lstTemp.push({
          archiveId: null,
          title: item.name,
          key: item.archiveId,
          isLeaf: !item.hasChild,
          parentId: item.archiveIdParent,
        });
      });
      let newTree;
      if (lstTemp[0]?.parentId) {
        newTree = updateTreeData(
          state.organizationArchiveFoldersDetails,
          lstTemp[0].parentId,
          lstTemp,
        );
      } else newTree = lstTemp;
      return {
        ...state,
        organizationArchiveFoldersDetails: newTree,
        organizationArchiveFoldersDetailsLoading: false,
      };
    }

    case ActionTypes.CHANGE_ARCHIVE_STATE_ITEMS_VALUE: {
      if (action.payload.type === '' || action.payload.key === '')
        return {
          ...state,
        };

      const { archiveModel } = state as IArchiveReducer;
      const itemKey = action.payload.key;
      const value = action.payload.value;
      archiveModel[itemKey] = value;
      return {
        ...state,
      };
    }

    case ActionTypes.FAST_ARCHIVE: {
      return {
        ...state,
      };
    }

    case ActionTypes.FAST_ARCHIVE_SUCCESS: {
      return {
        ...state,
      };
    }

    default:
      return state;
  }
};
